import React, { FC, useCallback } from 'react';
import { useApiIntegrations } from 'src/common/api/use-integrations.hook';
import { GoogleDriveIntegrationIcon } from 'src/monet/icons';
import { openPopupWindow } from 'src/utils/window';

type StepEditorContentLibraryAddIntegrationButtonProps = {
  onIntegrationAdded: () => void;
};

export const StepEditorContentLibraryAddIntegrationButton: FC<StepEditorContentLibraryAddIntegrationButtonProps> = ({
  onIntegrationAdded,
}) => {
  const { fetchAccessTokens } = useApiIntegrations();

  const receiveMessage = useCallback(
    (event) => {
      // Do we trust the sender of this message? (might be
      // different from what we originally opened, for example).
      const { data, isTrusted } = event;

      if (isTrusted && data) {
        fetchAccessTokens('google-drive');
        onIntegrationAdded();
      }
      // if we trust the sender and the source is our popup
      // get the URL params and redirect to our server to use Passport to auth/login
    },
    [fetchAccessTokens]
  );

  const onAddIntegration = useCallback(() => {
    openPopupWindow('/oauth/google-drive', 'google-drive-oauth', receiveMessage);
  }, [receiveMessage]);

  return (
    <button type='button' className='btn-bedrock-secondary px-1.5 py-0.5' onClick={onAddIntegration}>
      <div className='flex space-x-1'>
        <GoogleDriveIntegrationIcon className="w-5 h-5" />
        <span>Connect Google Drive</span>
      </div>
    </button>
  );
};
